import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import styles from './Modal.module.css';
const modalRoot = document.querySelector('#modal-root');
const ModalContainer = (props) => {
    if (modalRoot === null) {
        console.log('Err Root for modal is not working.');
        return null;
    }
    return ReactDOM.createPortal(_jsx("div", { className: styles.modalContainer, children: props.children }), modalRoot);
};
export default ModalContainer;
